import { action } from '../../../appLogic/appActions';

export const ADD_RESERVATION = action('ADD_RESERVATION');
